define.alias("shared/components/shared/profile-categorization/categorize-steps", "calendar/components/shared/profile-categorization/categorize-steps");